import { H1 } from "../../components/Text/Text";
import CreateNewAdvertiserShortBody from "./CreateNewAdvertiserShortBody";
import CreateNewAdvertiserShortFooter from "./CreateNewAdvertiserShortFooter";

import styles from './createNewAdvertiserShort.module.scss';

export default {
    header: <H1>Create new Advertiser</H1>,
    body: <CreateNewAdvertiserShortBody />,
    footer: <CreateNewAdvertiserShortFooter />,
    className: styles.wrapper,
};

export const CreateNewAdvertiserShortWithName = (name: string) => ({
    header: <H1>Create new Advertiser</H1>,
    body: <CreateNewAdvertiserShortBody advertiserName={name} />,
    footer: <CreateNewAdvertiserShortFooter />,
    className: styles.wrapper,
})